import { apiGateway } from "../api";

const cabecalho = {
    token: "1",
    unidadeNegocio: "1",
    divisaoNegocio: "1",
    origemContrato: "1",
    empresaOrigemAtendimento: "1",
    tipoContrato: "1",
    codigoEmpresaOrigem: "1"
};

async function getServiceList() {
    try {
        const body = {
            cabecalho,
            descricaoPerfil: "BENEFICIARIO"
        };

        const response = await apiGateway.post('/pesquisa-rede/atendimento/tipo', body);

        return response.data.tipoAtendimento;
    } catch (error) {
        return error;
    }
}

async function obtainSpecialtyList(codTipoAtendimento, numCarteirinha) {
    try {
        const body = {
            cabecalho,
            codigoTipoAtendimento: codTipoAtendimento,
            descricaoPerfil: "BENEFICIARIO",
            carteirinha: numCarteirinha,
        };

        const response = await apiGateway.post('/pesquisa-rede/especialidade/pesquisar', body);
        return response.data.especialidades;

    } catch (error) {
        return error;
    }
}

async function getUFCityAssistencialNetwork(numCarteirinha, codEspecialidade, codTipoAtendimento) {
    try {
        const body = {
            cabecalho,
            carteirinha: numCarteirinha,
            descricaoPerfil: "BENEFICIARIO",
            tipoAtendimento: codTipoAtendimento
        };

        if (codEspecialidade && codEspecialidade.trim()) {
            body.codigoEspecialidade = codEspecialidade;
        }

        const response = await apiGateway.post('/pesquisa-rede/cidade/pesquisar', body);

        return response.data.cidades;

    } catch (error) {
        return error;
    }
}

async function searchAssistencialNetworkList(body) {
    body.cabecalho = cabecalho;
    try {
        const response = await apiGateway.post('/pesquisa-rede/rede/regiao/pesquisar', body);

        return response.data.prestadores;
    } catch (error) {
        return error;
    }
}

async function providerDetails(body) {
    body.cabecalho = cabecalho;
    try {
        const response = await apiGateway.post('/pesquisa-rede/prestador/detalhar', body);

        return response.data;
    } catch (error) {
        return error;
    }
}

async function generateAccreditedPDF(body) {
    body.cabecalho = cabecalho;
    try {
        const response = await apiGateway.post('/pesquisa-rede/rede/regiao/pesquisar/gerar-pdf', body, {
            responseType: 'blob'
        });

        return response.data;
    } catch (error) {
        return error;
    }
}

async function generateProviderPDF(body) {
    body.cabecalho = cabecalho;
    try {
        const response = await apiGateway.post('/pesquisa-rede/prestador/endereco/codigo/pesquisar/gerar-pdf', body, {
            responseType: 'blob'
        });

        return response.data;

    } catch (error) {
        return error;
    }
}

export {
    getUFCityAssistencialNetwork,
    getServiceList,
    obtainSpecialtyList,
    searchAssistencialNetworkList,
    providerDetails,
    generateAccreditedPDF,
    generateProviderPDF
};